import React, { useState } from 'react';
import { auth } from '../../firebase';
import { updatePassword } from 'firebase/auth';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/sidebar/Sidebar';
import ActivityLog from '../activity/ActivityLog';
import { EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
import './changepassword.css';

function ChangePassword() {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const goBackHandler = () => {
        window.history.back();
    };

    const email = auth.currentUser.email;

    /**
     * Change password of current user
     * @param {*} e 
     */
    const handleSubmit = (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            toast.error("New passwords don't match");
            return;
        }
        // if (newPassword === confirmPassword) {
        const user = auth.currentUser;
        if (user) {
            setIsLoading(true);
            const credential = EmailAuthProvider.credential(user.email, currentPassword);

            reauthenticateWithCredential(user, credential)
                .then(() => {
                    return updatePassword(user, newPassword);
                })
                // updatePassword(user, newPassword)
                .then(() => {
                    ActivityLog('Password changed', email + ' password updated');
                    toast.success('Password updated successfully!');
                    setTimeout(() => navigate('/my-profile'), 1000);
                })
                .catch(error => {
                    const message = getFriendlyErrorMessage(error.code);
                    toast.error(message);
                    console.error('Error updating password:', error);
                })
                .finally(() => setIsLoading(false));

        }
    };
    const getFriendlyErrorMessage = (code) => {
        switch (code) {
            case 'auth/weak-password':
                return 'Password should be at least 6 characters long.';
            case 'auth/wrong-password':
                return 'The current password is incorrect.';
            case 'auth/too-many-requests':
                return 'Too many attempts. Please try again later.';
            default:
                return 'An unexpected error occurred. Please try again.';
        }
    };

    return (
<div className="change-password-container">
<Sidebar />
<div className="content">

<div className="password-card">
<h2 className='mb-5'>Change Password</h2>

                    <form onSubmit={handleSubmit}>
                        <label>Current Password</label>
                        <input
                            type="password"
                            placeholder="Current Password"
                            value={currentPassword}
                            onChange={e => setCurrentPassword(e.target.value)}
                            required
                        />
                        <label>New Password</label>
                        <input type="password"
                            placeholder="New Password"
                            value={newPassword}
                            onChange={e => setNewPassword(e.target.value)}
                            required
                        />
                        <label>Confirm New Password</label>
                        <input
                            type="password"
                            placeholder="Confirm New Password"
                            value={confirmPassword}
                            onChange={e => setConfirmPassword(e.target.value)}
                            required
                        />
                        <button type="submit" disabled={isLoading}>
                            {isLoading ? 'Processing...' : 'Change Password'}
                        </button>                    </form>
                    <button className='btn-back'
                        onClick={goBackHandler} >
                        Go Back
                    </button>
                </div>


            </div>
        </div>
    );
}

export default ChangePassword;
